import React from 'react';

const YoutubeMetaDataForm = ({youtubePostMetadata,handleYoutubeTitleChange,handleYoutubePrivacyStatusChange,handleYoutubeMetadataChange}) => {
    return  <div className='lg:col-span-1 overflow-auto'>
        <h4 className='text-2xl font-semibold mb-4'>
            YouTube Shorts Post Settings
        </h4>
        <div className='space-y-4'>
            <div>
                <label className='block mb-2'>Title</label>
                <input
                    type='text'
                    name='title'
                    value={youtubePostMetadata.title}
                    onChange={handleYoutubeTitleChange}
                    className='w-full p-2 border rounded'
                    maxLength={100}
                />
            </div>
            {/*public, private, or unlisted.*/}
            <div>
                <label className='block mb-2'>Privacy Status</label>
                <select
                    name='privacyStatus'
                    value={youtubePostMetadata.privacyStatus}
                    onChange={handleYoutubePrivacyStatusChange}
                    className='w-full p-2 border rounded'
                >
                    <option value=''>Select privacy status</option>
                    {['Public', 'Private', 'Unlisted'].map((option) => (
                        <option
                            key={option}
                            value={option}
                        >
                            {option}
                        </option>
                    ))}
                </select>
            </div>
            <div>
                <label className='block mb-2'>Description</label>
                <textarea
                    rows={4} // Adjust the number to increase or decrease height
                    type='text'
                    name='description'
                    value={youtubePostMetadata.description}
                    onChange={handleYoutubeMetadataChange}
                    className='w-full p-2 border rounded'
                />
            </div>
        </div>
    </div>
};

export default YoutubeMetaDataForm;
